// extracted by mini-css-extract-plugin
export default {"container":"order_online_container__wkVu+"};